import { store } from 'shared/stores/core/decorators';
import { pushOnce } from 'shared/util';

@store('IMAGE')
export class ImageStore {
  state = {
    imageIds: [],
    selectedImageId: null
  };

  USCOPE_BIND_EVENTS ({dispatch}, uScope) {
    uScope.events.on('uscope:viewport:selected', (viewport) => {
      dispatch('SET_SELECTED_IMAGE', { imageId: viewport.rawImageId });
    });
  }

  AFTER_VIEWPORT_CREATED ({dispatch}, viewport) {
    const {rawImageId} = viewport;
    const state = this.state;

    // Store the image Id
    pushOnce(state.imageIds, rawImageId);

    // Listen for select events to update the selected image id
    viewport.events.on('viewport:selected', () => {
      dispatch('SET_SELECTED_IMAGE', { imageId: rawImageId });
    });
  }

  SET_SELECTED_IMAGE ({dispatch}, {imageId}) {
    if (this.state.selectedImageId !== imageId) {
      this.state.selectedImageId = imageId;

      dispatch('IMAGE_SELECTED');
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/uScope/ImageStore.js